"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _hopsSdkJs = require("@hps/hops-sdk-js");
var _react = require("react");
var _Container = _interopRequireDefault(require("../Components/Container"));
var _Flex = _interopRequireDefault(require("../Components/Flex"));
var _Select = _interopRequireDefault(require("../Components/Select"));
var _String = _interopRequireDefault(require("../Components/String"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Checkout delivery method card
 * 
 * @package HOPS
 * @subpackage Checkout
 * @copyright Heritage Operations Processing Limited
 */const CheckoutDeliveryMethodCard = ({
  eligibleItems,
  caption,
  deliveryMethodCheckoutStrings,
  deliveryMethods,
  disabled,
  initialSelection,
  label,
  onChange,
  showDescription
}) => {
  const [selection, setSelection] = (0, _react.useState)(initialSelection);

  /**
   * Get our options.
   */
  const options = (0, _react.useMemo)(() => {
    return deliveryMethods?.map(deliveryMethod => {
      return {
        id: deliveryMethod.Id,
        label: `${deliveryMethod.Label} (${deliveryMethod.Price.Value === 0 ? "Free" : _hopsSdkJs.Localisation.formatCurrency(deliveryMethod.Price.Value)})`,
        value: deliveryMethod.Id
      };
    });
  }, [deliveryMethods]);

  /**
   * Update the filtered basket items with the new delivery method selection
   */
  const handleChange = selection => {
    setSelection(selection);
    onChange(eligibleItems, selection);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Container.default, {
    columns: "50% auto",
    gap: 4,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
      gap: 0,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
        bold: true,
        str: label
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
        color: "textSecondary",
        str: caption
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
      gap: 0.5,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.default, {
        disabled: disabled,
        label: "(Pick)",
        matchValue: id => deliveryMethods.find(({
          Id
        }) => Id === id),
        noOptionsLabel: "None available.",
        onChange: handleChange,
        options: options,
        required: true,
        showDefaultOption: true,
        size: "small",
        value: selection?.Id
      }), showDescription && /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
        color: "textSecondary",
        str: deliveryMethodCheckoutStrings?.find(s => s.DeliveryMethod === selection?.Id)?.CheckoutText,
        variant: "caption"
      })]
    })]
  });
};
var _default = exports.default = CheckoutDeliveryMethodCard;